import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response } from '@angular/http';
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Observable } from 'rxjs/Observable';
import { Utils } from './../shared/utils';
// import localStorage from 'localStorage';
// import { LocalStorageService, LOCAL_STORAGE_SERVICE_CONFIG } from 'angular-2-local-storage';

import 'rxjs/add/operator/toPromise';

import { URL_API } from './../constante';
import { HEADERS } from './../constante';
import { Usuario } from './usuario';

@Injectable()
export class UsuarioService {

  private headers = HEADERS;
  private loggedIn = false;
  private url_api = URL_API + '/acesso';
  private usuariosPorPerfilUrl = URL_API + "/usuarios/usuariosporperfil";

  constructor(
    private http: Http,
    private router: Router,
  ) {
    this.loggedIn = !!localStorage.getItem('auth_token');
  }
	
	getUsuariosPorPerfil(id:number): Promise<Usuario[]> {
      let url:string = this.usuariosPorPerfilUrl + "/" + id;
      return this.http.get(url)
                    .toPromise()
                    .then(response => response.json() as Usuario[])
                    .catch(this.handleError);
	}
	
  login(usuario: Usuario) {
    return this.http
               .post(this.url_api,
                 JSON.stringify(usuario),
                 { headers: HEADERS })
               .toPromise()
               .then(this.extractData)
               .catch(this.handleError);
  }

  logout() {
    localStorage.removeItem('auth_token');
    this.loggedIn = false;
  }

  isLoggedIn() {
    return this.loggedIn;
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  private extractData(res: Response) {
    let body = res.json();
    // console.log(body);
    if (body.id != 0) {
        console.log(body);
     //  res => res.json();
     //  localStorage.setItem('auth_token', res.json().);
      // this.loggedIn = true;
      let rout: Router;
      rout.navigate(['/inicio']);
    } else {
      console.log("Acesso negado!");
    }
    // return body.data || { };
  }
}



// WEBPACK FOOTER //
// ./src/app/usuario/usuario.service.ts